import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { OrgTypes } from '@mode/shared/contract-common';
import { ColorSwatchFlyoutComponent } from '../color-swatch-flyout/color-swatch-flyout.component';

@Component({
  standalone: true,
  imports: [ColorSwatchFlyoutComponent, CommonModule, MatLegacyMenuModule],
  selector: 'mode-unassigned-color-picker',
  templateUrl: './unassigned-color-picker.component.html',
  styleUrls: ['./unassigned-color-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnassignedColorPickerComponent implements OnChanges {
  @Input() allColorPalettes: OrgTypes.ColorPalette[] = [];
  @Input() selectedColorPalette: OrgTypes.ColorPalette | undefined;
  @Input() color = '';
  @Input() vizToken = '';

  @Output() colorSelected = new EventEmitter<string>();

  currentColor = '';
  currentPalette: OrgTypes.ColorPalette | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['color']) {
      this.currentColor = changes['color'].currentValue;
    }
    if (changes['selectedColorPalette']) {
      this.currentPalette = changes['selectedColorPalette'].currentValue;
    }
  }

  colorUpdated(selectedColor: string, selectedPalette: OrgTypes.ColorPalette) {
    this.currentColor = selectedColor;
    this.currentPalette = selectedPalette;
    this.colorSelected.emit(selectedColor);
  }
}
